import React from 'react';
import Method from "./Method";

const Endpoints = (props) => {
    return (
        <div>
            <Method title={"ENDPOINTS"} white>
                {
                    props.data.map(i => (
                        <div>
                            <div className="row">
                                <div className="col-2"> 
                                    <b className={`${i.method === 'GET' ? "text-primary" : i.method === "POST" ? "text-success" : 'text-danger'}`}>
                                        {i.method.toUpperCase()}
                                    </b> 
                                </div>
                                <div className="col-10"> 
                                    <text className="text-black-50">
                                        {i.url}
                                    </text>
                                </div>
                            </div>
                        </div>
                    ))
                }
              
            </Method>
        </div>
    )
}

export default Endpoints